import React from 'react';
import { TagCloud } from 'react-tagcloud';
import { Badge, Card, Form, OverlayTrigger, Tooltip, Button, Fade, Spinner, Navbar, Nav } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Moment from 'react-moment';
import 'moment/locale/zh-tw';
import ReactMarkdown from 'react-markdown';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

const debug = false;
const boards = [
    '八卦板', '棒球板', 'Steam板', "西洽板"
]
const defaultBoard = boards[0];
//put data at public/ when testing
const boardDataLinks = {
    '八卦板': "./keyword/Gossiping-keyword.json",
    '棒球板': "./keyword/Baseball-keyword.json",
    'Steam板': "./keyword/Steam-keyword.json",
    "西洽板": "./keyword/C_Chat-keyword.json"
}

//TODO: search bar
//TODO: add ads(wait google response), bloggerads, 廣告王
//TODO: write readme
//TODO: app version? react-native
//TODO: 切換TAB動畫
//TODO: REACTJS seo
//TODO: remember last choosed option by cookie or something? https://www.npmjs.com/package/react-cookie
//TODO: add already read articles css
//TODO: use same seed to generate the same cloud for the same content
//TODO: use yarn
//TODO: use helmet instead meta tags

class PTTTagCloudNavbar extends React.Component {
    constructor(props) {
        super(props);

        this.myRef = React.createRef();
        this.scrollToTop = this.scrollToTop.bind(this);
        this.onChangeBoard = this.onChangeBoard.bind(this);
        this.onChangeBoardApp = this.props.onChangeBoard.bind(this);
    }

    scrollToTop = () => window.scrollTo(0, this.myRef.current.offsetTop);

    onChangeBoard(event) {
        const board = event.target.value;
        this.onChangeBoardApp(board);
    }

    render() {
        const boardOptions = this.props.boards.map((board, index) =>
            <option key={board}>{board}</option>
        );

        return (
            <>
                <div ref={this.myRef}></div>
                <Navbar sticky="top" bg="light" expand="md">
                    <Navbar.Brand href=".">
                        <img
                            alt="logo"
                            src="logo192.png"
                            width="50"
                            height="50"
                            className="d-inline-block align-top"
                        />{'  '}
                        <Navbar.Text>
                            PTT文字雲
                        </Navbar.Text>
                    </Navbar.Brand>
                    <Form inline>
                        <Form.Control
                            as="select"
                            size="lg"
                            defaultValue={defaultBoard}
                            onChange={this.onChangeBoard}>
                            {boardOptions}
                        </Form.Control>
                    </Form>
                    <Navbar.Toggle aria-controls="navbar-tabs" />
                    <Navbar.Collapse id="navbar-tabs" className="justify-content-end">
                        <Nav>
                            <Nav.Link as={Link} to="/">文字雲</Nav.Link>
                            <Nav.Link as={Link} to="about">如何運作</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                    <Navbar.Collapse id="navbar-links" className="justify-content-end">
                        <Nav.Link onClick={this.scrollToTop}>Top</Nav.Link>
                        <Nav.Link href="mailto:goohcl777@gmail.com"
                            rel="noopener norefferer">問題回報</Nav.Link>
                        <Nav.Link href="https://qwerty777.me" target="_blank"
                            rel="noopener norefferer">關於作者</Nav.Link>
                    </Navbar.Collapse>
                </Navbar>
            </>
        );
    }
}


class PTTTagCloud extends React.Component {
    constructor(props) {
        super(props);
        this.colorOption = {// put data at here(not in render()) to prevent re-render
            luminosity: 'bright',
            hue: '#990'
            //d3d3d3 telnet text(silver)
            //aaaaaa web text(white)
            //66ff66 push count(yellow)
            //999999 WEB INNER(white)
            //#990 PUSH TEXT(green)
        };
        this.state = { tagData: this.props.tagData };
    }

    render() {
        const tagRenderer = (tag, size, color) => (
            <span
                className="tag-cloud-tag"
                key={`${tag.value}`}
                style={{
                    fontSize: `${size}px`,
                    margin: '0px 3px',
                    verticalAlign: 'middle',
                    display: 'inline-block',
                    color: `${color}`,
                }}
            >
                {tag.value}
            </span>
        );
        return (
            <>
                <TagCloud
                    minSize={18}
                    maxSize={40}
                    tags={this.props.tagData}
                    colorOptions={this.colorOption}
                    shuffle={true}
                    onClick={this.props.onClick}
                    renderer={tagRenderer}
                />
            </>
        );
    }
}
class RelatedArticles extends React.Component {
    constructor(props) {
        super(props);
        this.setDefaultImg = this.setDefaultImg.bind(this);
    }

    setDefaultImg(ev) {
        ev.target.src = 'logo192.png';
    }

    GetArticle(articleInfo, index) {
        const article = this.props.articleData[articleInfo.url];

        const commentData = article.commentCount;
        const commentTooltip = (props) => (
            <Tooltip {...props}>
                {`${commentData.push}推/${commentData.neutral}→/${commentData.boo}噓/${commentData.all}個評論`}
            </Tooltip>
        );
        const commentCount = (
            <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={commentTooltip}
            >
                <Button variant={(commentData.count >= 0) ? "warning" : "dark"}>
                    {commentData.count}
                </Button>
            </OverlayTrigger>
        );

        const tags = article.tags.map(function (tag, index) {
            return (
                <Badge pill variant="info" style={{ margin: 2.5 }} key={tag[0]}>
                    {tag[0]}
                </Badge>
            );
        });

        //TODO: fade out when unmount
        //TODO: highlight tag in content text
        const secureURL = articleInfo.url.replace("http://", "https://");
        if (secureURL !== articleInfo.url) {
            console.log("replace https" + articleInfo.url);
        }
        return (
            <Fade appear={true} in={true} timeout={800} key={secureURL}>
                <Card
                    as="a"
                    className="cardlink"
                    href={secureURL}
                    target="_blank"
                    rel="noopener norefferer"
                    style={{ marginBottom: 30 }}
                >
                    <Card.Header style={{ fontSize: 20, fontWeight: 'bold' }}>
                        {commentCount} {article.title}<br />
                        {tags}
                    </Card.Header>
                    {(article.image) && <Card.Img onError={this.setDefaultImg} src={article.image} alt={article.title} />}
                    <Card.Body>
                        <Card.Text>
                            {article.content}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Fade>
        );
    }

    render() {
        let articleMetas = this.props.articleMetas;
        articleMetas.sort((a, b) => a["weight"] < b["weight"] ? 1 : -1);

        const cardColumns = [0, 1, 2].map((i) =>
            <div className="cardColumn" key={i}>
                {articleMetas.map((info, index) =>
                    (index % 3 === i) ? this.GetArticle(info, index) : null
                )}
            </div>
        );

        const articleHeader = (
            (articleMetas.length > 0) &&
            <h2 className="mytext article-summary">
                <span className="boardName">{this.props.board}</span> 中{' '}
                <span className="tagName">{this.props.tag}</span> 的相關文章
                共 {articleMetas.length} 篇
            </h2>
        );
        return (
            //TODO: sort by 推, time, or relavance to tags
            /*
            <Form>
                    <Form.Group controlId="sortArticleMethod">
                        <Form.Control
                            as="select"
                            defaultValue="relavance"
                            onChange={this.onChangeSort}>
                            {sortOptions}
                        </Form.Control>
                    </Form.Group>
                </Form>
            */
            <div>
                {articleHeader}
                < div className="cardColumns" >
                    {cardColumns}
                </div >
                {debug && articleMetas && <h2>{JSON.stringify(articleMetas)}</h2>}
            </div >
        );
    }
}

class About extends React.Component {
    render() {
        const text =
            `### 如何運作
1. 取得文章資料
2. 計算文章關鍵字及權重
3. 取得總權重最高的詞組及相關文章
4. 每一小時更新資料
### 使用套件
- jieba
- [ptt-web-crawler](https://github.com/jwlin/ptt-web-crawler)
- reactjs
### 使用語言
- Javascript
- Python
`;
        return (
            <div className="center">
                <ReactMarkdown
                    className="markdown-text"
                    style={{ color: "white" }}
                    source={text}
                />
            </div>
        );
    }
}

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = { articles: [], tag: "", board: defaultBoard, isLoaded: false, boardDatas: {} };
        this.onChangeTag = this.onChangeTag.bind(this);
        this.onChangeBoard = this.onChangeBoard.bind(this);
        this.setLoaded = this.setLoaded.bind(this);
    }

    componentDidMount() {
        //TODO: lazyload
        this.loadBoardData(defaultBoard);
        boards.forEach((board) => {
            if (board !== defaultBoard) {
                this.loadBoardData(board);
            }
        });
        /*
                //useScript('//js1.bloggerads.net/ShowBanner.aspx?blogid=20200820000002');
                //useScript('https://shopsquare.co/ads_output.php?k=2iHHW&uid1=ptt');
                //https://stackoverflow.com/questions/34424845/adding-script-tag-to-react-jsx
                const script = document.createElement("script");
        
                script.src = "https://shopsquare.co/ads_output.php?k=2iHHW&uid1=ptt";
                script.async = true;
        
                document.body.appendChild(script);
                */
    }

    setLoaded() {
        this.setState({
            isLoaded: true
        });
    }

    loadBoardData(board) {//ref: https://reactjs.org/docs/faq-ajax.html
        //console.log("load board data" + board + boardDataLinks[board]);
        fetch(boardDataLinks[board])
            .then(res => res.json())
            .then(
                (result) => {
                    const boardData = this.state.boardDatas;
                    boardData[board] = {
                        articles: result.articles,
                        tags: result.tags,
                        lastUpdateTime: result.lastUpdate
                    };

                    setTimeout(this.setLoaded,
                        0
                    )
                    this.setState({
                        boardDatas: boardData,
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            );
    }

    onChangeTag(tag) {
        this.setState({
            articles: tag.articles,
            tag: tag.value
        });
    }

    onChangeBoard(board) {
        this.setState({
            board: board,
            articles: [],
            tag: ""
        });
    }

    render() {
        const navbar =
            <PTTTagCloudNavbar
                boards={boards}
                onChangeBoard={this.onChangeBoard}
            />;
        const loading =
            <div className="loading-div">
                <Spinner animation="border" variant="primary" className="loading">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </div>;

        let content;
        if (this.state.error) {
            content = <div> Error: {this.state.error.message}</div>;
        } else if (!this.state.isLoaded) {
            content = loading;
        } else {
            const { board, boardDatas } = this.state;
            const boardData = boardDatas[board];

            if (!boardData) {//XXX:
                content = loading;
            } else {
                const lastUpdateDate = new Date(boardData.lastUpdateTime * 1000);
                const lastUpdateDuration = <Moment fromNow>{lastUpdateDate}</Moment>;
                const articles = boardData.articles;
                const tags = boardData.tags;

                const tagContent = (
                    <>
                        <PTTTagCloud
                            tagData={tags}
                            onClick={this.onChangeTag}
                        />
                        <RelatedArticles
                            id="articles"
                            board={board}
                            tag={this.state.tag}
                            articleMetas={this.state.articles}
                            articleData={articles}
                        />
                        <p className="mytext footer">
                            資料更新時間: {lastUpdateDuration}
                        </p>
                        <p>{debug && JSON.stringify(boardData.articles)}</p>
                    </>
                );

                content = (
                    <>
                        <Switch>
                            <Route exact path="/">
                                {tagContent}
                            </Route>
                            <Route path="/about">
                                <About />
                            </Route>
                        </Switch>
                    </>
                );
            }
        }

        return (
            <>
                <Router basename="/ptt-tag-cloud">
                    {navbar}
                    {content}
                </Router>
            </>
        );

    }
}

export default App;
